import { apiRequest } from './apiClient';

export const EXTERNAL_ACCOUNT_LINK_UPDATED_EVENT = 'agromart:external-account-link-updated';

const normalizeSystem = (value) => `${value || ''}`.trim().toUpperCase();

const emitLinkUpdated = (system, response) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(EXTERNAL_ACCOUNT_LINK_UPDATED_EVENT, {
    detail: {
      system: normalizeSystem(system),
      response,
    },
  }));
};

export const fetchExternalAccountLink = (system) =>
  apiRequest(`/external-account-links/${normalizeSystem(system)}`, { auth: true });

export const initiateExternalAccountLink = async (system, body) => {
  const response = await apiRequest(`/external-account-links/${normalizeSystem(system)}/initiate`, {
    method: 'POST',
    auth: true,
    body,
  });

  emitLinkUpdated(system, response);
  return response;
};

export const confirmExternalAccountLink = async (system, body) => {
  const response = await apiRequest(`/external-account-links/${normalizeSystem(system)}/confirm`, {
    method: 'PATCH',
    auth: true,
    body,
  });

  emitLinkUpdated(system, response);
  return response;
};

export const revokeExternalAccountLink = async (system) => {
  const response = await apiRequest(`/external-account-links/${normalizeSystem(system)}`, {
    method: 'DELETE',
    auth: true,
  });

  emitLinkUpdated(system, response);
  return response;
};
